import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import { colors } from 'vuetify/lib';

Vue.use(Vuetify)

const systemTheme =
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches

const green = '#2d9a47'
// const cyan = '#17c4a1';
const indigo = '#8883fb'
const blue = '#25a4fb'
const yellow = '#ffa829'
const pink = '#fe6172'

export default new Vuetify({
  theme: {
    dark: false && systemTheme,
    themes: {
      light: {
        primary: green,
        info: indigo,
        success: blue,
        danger: pink,
        warning: yellow
      },
      dark: {
        primary: green,
        info: indigo,
        success: blue,
        danger: pink,
        warning: yellow
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
